export const DEFAULT_USER_ID = -1;
export const DEFAULT_USERNAME = "Atlanter";
